import 'normalize.css';
import Vue from 'vue';
import VeeValidate, { Validator } from 'vee-validate';
import zh_CN from 'vee-validate/dist/locale/zh_CN';
import App from './App.vue';
import store from './store';
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
Vue.use(ElementUI);
Vue.use(VeeValidate, {
  events: 'change'
});
Validator.localize('zh', zh_CN);
Validator.localize({
  zh: {
    messages: {
      required: (fieldName, e, a) => {
        var displayName ;
        switch (fieldName){
          case 'firstName': displayName = '姓';
            break;
          case 'lastName': displayName = '名';
            break;
          case 'mobile': displayName = '手机号';
            break;
          case 'email': displayName = '邮箱';
            break;
          case 'loginName': displayName = '手机号或者邮箱';
            break;
          case 'verfiyCode': displayName = '验证码';
            break;
          case 'enterprise': displayName = '公司';
            break;
          case 'dAddress': displayName = '详细地址';
            break;
          case 'areaA' : displayName = '地区';
            break;
          case 'province' :displayName = '省份';
            break;
          case 'zhiwei' : displayName = '职位';
            break;
          case 'city' : displayName = '城市';
            break;
          case 'emailNew' : displayName = '邮箱';
            break;
          case 'country' : displayName = '国家';
            break;
          case 'postCode' : displayName = '邮编';
            break;
        }
        return '请输入正确的'+ displayName;
      },
      min: (fieldName, e, a) => {
        var displayName ;
        switch (fieldName){
          case 'firstName': displayName = '姓';
            break;
          default: displayName = '验证码'
            break
        }
        return '请输入正确的'+ displayName;
      }
    }
  }
});

Validator.extend('loginName', {
  getMessage: () => '请输入正确的手机号或者邮箱',
  validate: value => {
    return /^1(3|4|5|6|7|8|9)\d{9}$/.test(value) || /^(\w)+(.|-\w+)*@(.|-|\w)+((\.\w+)+)$/.test(value) || /^(\+|\-){0,1}\d{4,15}$/.test(value)
  }
});
Validator.extend('mobile', {
  getMessage: () => '请输入正确的手机号',
  validate: value => {
    return /^1(3|4|5|6|7|8|9)\d{9}$/.test(value)
  }
});

Validator.extend('email', {
  getMessage: () => '请输入正确的邮箱',
  validate: value => {
    return /^(\w)+(.|-\w+)*@(.|-|\w)+((\.\w+)+)$/.test(value)
  }
});

Validator.extend('emailNew', {
  getMessage: () => '请输入正确的邮箱',
  validate: value => {
    return /^(\w)+(.|-\w+)*@(.|-|\w)+((\.\w+)+)$/.test(value)
  }
});

Validator.extend('firstName', {
  getMessage: () => '请输入正确的名',
  validate: value => {
    return /^[\u4E00-\u9FA5]{1,2}|[a-zA-Z]{1,20}$/.test(value)
  }
});

Validator.extend('firstName', {
  getMessage: () => '请输入正确的姓',
  validate: value => {
    return /^[\u4E00-\u9FA5]{1,2}|[a-zA-Z]{1,20}$/.test(value)
  }
});

Validator.extend('enterprise', {
  getMessage: () => '请输入正确的公司',
  validate: value => {
    return /^((?! {2,}).)+$/.test(value)
  }
});
Vue.config.productionTip = false;

new Vue({
  store,
  render: h => h(App),
}).$mount('#app');
